module.exports = __webpack_public_path__ + "static/img/15.6849651.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/sp/15.png
// module id = 9iAj
// module chunks = 0